/*
  LymphBalance product page behaviour. Each initialiser marks the element it
  wires up, so running init() again (theme editor section reloads) only touches
  new markup.
*/
(function () {
  if (window.LbPdp) return;

  // The marker gets its own data-*-ready attribute so it never overwrites the
  // data-lbp-* hook it shares a name with (e.g. data-lbp-sticky holds a target id).
  function once(el, key) {
    var flag = key + 'Ready';
    if (el.dataset[flag]) return false;
    el.dataset[flag] = 'true';
    return true;
  }

  // Horizontal scroll-snap slider with optional arrows and generated dots.
  function initSlider(root) {
    if (!once(root, 'lbpSlider')) return;

    var track = root.querySelector('[data-lbp-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var prev = root.querySelector('[data-lbp-prev]');
    var next = root.querySelector('[data-lbp-next]');
    var dotsWrap = root.querySelector('[data-lbp-dots]');
    var dots = [];

    function step() {
      if (slides.length < 2) return track.clientWidth;
      return slides[1].offsetLeft - slides[0].offsetLeft;
    }

    function current() {
      return Math.round(track.scrollLeft / Math.max(step(), 1));
    }

    function maxIndex() {
      return Math.max(0, Math.ceil((track.scrollWidth - track.clientWidth) / Math.max(step(), 1) - 0.05));
    }

    function goTo(index) {
      track.scrollTo({ left: index * step(), behavior: 'smooth' });
    }

    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      dots = [];
      var count = maxIndex() + 1;
      if (count < 2) return;
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'lbp__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        dot.addEventListener('click', goTo.bind(null, i));
        dotsWrap.appendChild(dot);
        dots.push(dot);
      }
    }

    function sync() {
      var index = current();
      dots.forEach(function (dot, i) {
        dot.setAttribute('aria-current', i === index ? 'true' : 'false');
      });
      if (prev) prev.disabled = track.scrollLeft <= 2;
      if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
    }

    if (prev) prev.addEventListener('click', function () { goTo(Math.max(0, current() - 1)); });
    if (next) next.addEventListener('click', function () { goTo(Math.min(maxIndex(), current() + 1)); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        sync();
      });
    }, { passive: true });

    window.addEventListener('resize', function () {
      buildDots();
      sync();
    });

    buildDots();
    sync();
  }

  function initGallery(root) {
    if (!once(root, 'lbpGallery')) return;

    var track = root.querySelector('[data-lbp-gallery-track]');
    if (!track) return;
    var slides = Array.prototype.slice.call(track.children);
    var thumbs = Array.prototype.slice.call(root.querySelectorAll('[data-lbp-thumb]'));
    var thumbWrap = root.querySelector('[data-lbp-thumbs]');

    function index() {
      return Math.round(track.scrollLeft / Math.max(track.clientWidth, 1));
    }

    function goTo(i) {
      var clamped = (i + slides.length) % slides.length;
      track.scrollTo({ left: clamped * track.clientWidth, behavior: 'smooth' });
    }

    // Keeps the active thumbnail visible; the strip is vertical on desktop.
    function reveal(thumb) {
      if (!thumbWrap) return;
      var vertical = thumbWrap.scrollHeight > thumbWrap.clientHeight + 1;
      if (vertical) {
        var top = thumb.offsetTop - thumbWrap.offsetTop;
        if (top < thumbWrap.scrollTop || top + thumb.offsetHeight > thumbWrap.scrollTop + thumbWrap.clientHeight) {
          thumbWrap.scrollTo({ top: top, behavior: 'smooth' });
        }
      } else {
        var left = thumb.offsetLeft - thumbWrap.offsetLeft;
        if (left < thumbWrap.scrollLeft || left + thumb.offsetWidth > thumbWrap.scrollLeft + thumbWrap.clientWidth) {
          thumbWrap.scrollTo({ left: left, behavior: 'smooth' });
        }
      }
    }

    function sync() {
      var active = index();
      thumbs.forEach(function (thumb, i) {
        var on = i === active;
        thumb.setAttribute('aria-current', on ? 'true' : 'false');
        if (on) reveal(thumb);
      });
    }

    thumbs.forEach(function (thumb, i) {
      thumb.addEventListener('click', function () { goTo(i); });
    });

    var prev = root.querySelector('[data-lbp-gallery-prev]');
    var next = root.querySelector('[data-lbp-gallery-next]');
    if (prev) prev.addEventListener('click', function () { goTo(index() - 1); });
    if (next) next.addEventListener('click', function () { goTo(index() + 1); });

    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        ticking = false;
        sync();
      });
    }, { passive: true });

    sync();
  }

  // One-time vs subscribe cards: swap the button prices and the selling_plan field.
  function initBuyBox(root) {
    if (!once(root, 'lbpBuy')) return;

    var plans = Array.prototype.slice.call(root.querySelectorAll('[data-lbp-plan]'));
    var planInput = root.querySelector('[data-lbp-plan-input]');
    var priceEl = root.querySelector('[data-lbp-atc-price]');
    var compareEl = root.querySelector('[data-lbp-atc-compare]');
    var d = root.dataset;

    function render(subscribe) {
      var useSub = subscribe && !!d.subPrice;
      var compare = useSub ? d.subCompare : d.compare;
      if (priceEl) priceEl.textContent = useSub ? d.subPrice : d.price;
      if (compareEl) {
        compareEl.textContent = compare || '';
        compareEl.hidden = !compare;
      }
      if (planInput) {
        planInput.value = useSub ? d.plan : '';
        planInput.disabled = !useSub;
      }
    }

    function choose(plan) {
      plans.forEach(function (p) {
        var on = p === plan;
        p.setAttribute('aria-checked', on ? 'true' : 'false');
        p.tabIndex = on ? 0 : -1;
      });
      render(plan.dataset.lbpPlan === 'subscribe');
    }

    plans.forEach(function (plan, i) {
      plan.addEventListener('click', function () { choose(plan); });
      plan.addEventListener('keydown', function (event) {
        var key = event.key;
        if (key === ' ' || key === 'Enter') {
          event.preventDefault();
          choose(plan);
          return;
        }
        var dir = key === 'ArrowDown' || key === 'ArrowRight' ? 1 : key === 'ArrowUp' || key === 'ArrowLeft' ? -1 : 0;
        if (!dir) return;
        event.preventDefault();
        var target = plans[(i + dir + plans.length) % plans.length];
        target.focus();
        choose(target);
      });
    });

    var initial = plans.filter(function (p) { return p.getAttribute('aria-checked') === 'true'; })[0];
    render(!!initial && initial.dataset.lbpPlan === 'subscribe');
  }

  function ordinal(n) {
    var s = ['th', 'st', 'nd', 'rd'];
    var v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }

  function initShipDate(el) {
    if (!once(el, 'lbpShip')) return;
    var days = parseInt(el.dataset.lbpShipDate, 10) || 0;
    var date = new Date();
    date.setDate(date.getDate() + days);
    var month = date.toLocaleString(el.dataset.locale || 'en-AU', { month: 'long' });
    el.textContent = month + ' ' + ordinal(date.getDate());
  }

  // Evergreen countdown: each visitor gets their own deadline, kept for the session.
  function initCountdown(root) {
    if (!once(root, 'lbpCountdown')) return;

    var minutes = parseInt(root.dataset.lbpCountdown, 10) || 120;
    var key = 'lbp-countdown-' + (root.dataset.key || 'default');
    var end = 0;
    try {
      end = parseInt(sessionStorage.getItem(key), 10) || 0;
    } catch (e) {}
    if (!end || end < Date.now()) {
      end = Date.now() + minutes * 60000;
      try {
        sessionStorage.setItem(key, String(end));
      } catch (e) {}
    }

    var h = root.querySelector('[data-h]');
    var m = root.querySelector('[data-m]');
    var s = root.querySelector('[data-s]');
    function pad(n) { return (n < 10 ? '0' : '') + n; }

    function tick() {
      var left = Math.max(0, Math.floor((end - Date.now()) / 1000));
      if (h) h.textContent = pad(Math.floor(left / 3600));
      if (m) m.textContent = pad(Math.floor((left % 3600) / 60));
      if (s) s.textContent = pad(left % 60);
    }

    tick();
    setInterval(tick, 1000);
  }

  function initSticky(bar) {
    if (!once(bar, 'lbpSticky')) return;

    var target = document.getElementById(bar.dataset.lbpSticky);
    var watch = target && (target.querySelector('[data-lbp-submit]') || target);
    var btn = bar.querySelector('[data-lbp-sticky-btn]');

    if (btn && target) {
      btn.addEventListener('click', function () {
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    if (!watch || !('IntersectionObserver' in window)) return;

    var passed = false;
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        passed = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', passed);
        bar.setAttribute('aria-hidden', passed ? 'false' : 'true');
        if (btn) btn.tabIndex = passed ? 0 : -1;
      });
    }).observe(watch);
  }

  function each(selector, fn) {
    Array.prototype.forEach.call(document.querySelectorAll(selector), fn);
  }

  function init() {
    each('[data-lbp-slider]', initSlider);
    each('[data-lbp-gallery]', initGallery);
    each('[data-lbp-buy]', initBuyBox);
    each('[data-lbp-ship-date]', initShipDate);
    each('[data-lbp-countdown]', initCountdown);
    each('[data-lbp-sticky]', initSticky);
  }

  window.LbPdp = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
